export default {
  setUser(state, payload) {
    state.token = payload.token;
    state.email = payload.email;
    state.gravatar_url = payload.gravatar_url;
  },
  setAutoLogout(state) {
    //state.didAutoLogout = true;
  }
};